import React from "react";
import { Helmet } from "react-helmet";
import ShowDetails from "./ShowDetails";
import { BookingRequest } from "./BookingRequest";
import { Photos } from "./Photos";

export function Home() {
    return (
        <div>
            <Helmet>
                <title>Zayne Browning</title>
            </Helmet>

            <div className="main-content">
                <div className="hero-spacer"></div>

                { /* Music */}
                <div className="music container section" id="music">
                    <h2 className="heading-secondary">Music</h2>
                    <div className="margin-bottom-large">New music 2025.</div>
                    <div className="youtube-video">
                        <iframe width="100%" height="740" src="https://www.youtube.com/embed/PQ7fXWsdZiU?si=I75rgicDoThz_3HB" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>

                { /* Upcoming Shows */}
                <div className="upcoming-shows container section" id="upcomingShows">
                    <h2 className="heading-secondary">Upcoming Shows</h2>

                    <div className="shows-list">
                        <ShowDetails date="Friday, May 1, 2026" venue="Pappy Jacks Decatur" location="Decatur, TX" time="8:00PM - 11:00PM" link="#" />
                        <ShowDetails date="Saturday, May 2, 2026" venue="Boots and Badges Benefit Event" location="Runaway Bay, TX" time="TBD" link="#" />
                        <ShowDetails date="Friday, June 5, 2026" venue="Cocktails Bar and Grill" location="Azle, TX" time="9:00PM - 12:00AM" link="#" />
                        <ShowDetails date="Saturday, June 6, 2026" venue="Private Event-BCC" location="Bridgeport, TX" time="TBD" link="#" />
                        <ShowDetails date="Friday, June 12, 2026" venue="Reina's Bar and Grill" location="Bridgeport, TX" time="8:00PM - 11:00PM" link="#" />
                        <ShowDetails date="Friday, July 17 - Saturday, July 18, 2026" venue="Oilbelt Bash Golf Tournament and Concert" location="Midland, TX" time="TBD" link="#" />
                        <ShowDetails date="Saturday, August 1, 2026" venue="Private Event" location="Sunset, TX" time="5:00PM - 7:00PM" link="#" />
                   </div>
                </div>

                { /* Booking Request */ }
                <div className="booking-request section" id="bookings">
                    <BookingRequest />
                </div>

                { /* Photos */ }
                <div className="photos section" id="photos">
                    <Photos />
                </div>
            </div>
        </div>
    );
}